@if (isLoading) {
  <div class="inventory-item-tab__spinner">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">{{ 'MESSAGES.LOADING' | translate }}</span>
    </div>
  </div>
}

@if (viewModel$ | async; as vm) {
  <div class="inventory-item-description-tab" [formGroup]="overviewForm.form">
    @if (vm.previewFieldLabelKey) {
      <p class="inventory-item-tab__notice-text inventory-item-description-tab__notice">
        {{ 'COMPONENTS.INVENTORY_ITEM_OVERVIEW.PREVIEW_UPDATED' | translate: { field: (vm.previewFieldLabelKey | translate) } }}
      </p>
    }

    <div class="inventory-item-tab__fields-grid inventory-item-description-tab__fields">
      @for (field of vm.fields; track field.controlName) {
        <app-dynamic-editable-field
          class="inventory-item-tab__field-row inventory-item-description-tab__field inventory-item-description-tab__field--wide"
          [formControlName]="field.controlName"
          layout="stacked"
          [inputType]="field.inputType ?? 'text'"
          editorClass="inventory-item-description-tab__editor"
          (updatedInput)="onPreviewFieldUpdate(field.controlName)"
        >
          <ng-template #labelTpl>
            <div class="inventory-item-tab__field-label-text inventory-item-description-tab__field-label">
              {{ field.label | translate }}
            </div>
          </ng-template>

          <ng-template #contentTpl>
            <div class="inventory-item-tab__field-value-text inventory-item-description-tab__field-value">
              {{ field.value }}
            </div>
          </ng-template>

          <ng-template #inputTpl let-control="control">
            <textarea
              class="form-input form-textarea dynamic-editable-field__input inventory-item-description-tab__textarea"
              [formControl]="control.control"
              rows="6"
            ></textarea>
          </ng-template>
        </app-dynamic-editable-field>
      }
    </div>
  </div>
}
